<template>
  <b-nav-item @click="goTo">
    {{ name }}
  </b-nav-item>
</template>

<script>
export default {
  computed: {
    name () {
      return this.$store.state.nav.siteName
    }
  },

  methods: {
    goTo () {
      this.$router.push({ name: 'users' })
    }
  }
}
</script>
